import { UIEvent, useCallback } from "react"

export function useNearBottom(onReach: () => void, threshold = 40) {
  return useCallback(
    (e: UIEvent<HTMLDivElement>) => {
      const el = e.currentTarget
      if (el.scrollHeight - el.scrollTop - el.clientHeight <= threshold) {
        onReach()
      }
    },
    [onReach, threshold]
  )
}